import React from 'react';

import { ActionIcon, Box, Group, Stack, Text } from '@mantine/core';
import {
    IconChevronDown,
    IconPlayerSkipBack,
    IconPlayerSkipForward,
    IconMusic,
} from '@tabler/icons-react';
import { Sheet } from 'react-modal-sheet';
import { useModule } from '@/hooks/useModule';
import { PlayIcon } from '@/modules/audio_player/audio_player_module';
import { AudioSeekBar } from '@/components/AudioSeekBar';

interface FullPlayerProps {
    isOpen: boolean;
    onClose: () => void;
}

export function FullPlayer({ isOpen, onClose }: FullPlayerProps) {
    const audioPlayerModule = useModule('AudioPlayer');
    const playbackStatus = audioPlayerModule.useAudioPlaybackStatus();

    const songTitle = playbackStatus?.fileInfo?.name?.replace(/\.[^/.]+$/, '') ?? 'No song playing';

    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            tweenConfig={{
                duration: 0.2,
                ease: 'easeOut'
            }}
        >
            <Sheet.Container
                style={{
                    backgroundColor: 'var(--mantine-color-body)',
                }}
            >
                <Sheet.Header />
                <Sheet.Content
                    style={{
                        backgroundColor: 'var(--mantine-color-body)',
                    }}
                >
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: 20,
                            height: '100%',
                        }}
                    >
            <Box style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
                <ActionIcon variant="transparent" size="lg" onClick={onClose}>
                    <IconChevronDown size={32} />
                </ActionIcon>
            </Box>

            <Stack gap="xl" style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <Stack gap="xs" style={{ width: '100%', textAlign: 'center' }}>
                    <Text size="xl" fw={600}>
                        {songTitle}
                    </Text>
                </Stack>

                <AudioSeekBar showTimeLabels={true} />

                <Group gap="xl" justify="center" style={{ marginTop: 20 }}>
                    <ActionIcon variant="transparent" size={50} disabled>
                        <IconPlayerSkipBack size={32} />
                    </ActionIcon>

                    {playbackStatus?.fileInfo && (
                        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <PlayIcon
                                fileInfo={playbackStatus.fileInfo}
                                size={60}
                                style={{
                                    background: 'var(--mantine-color-filled)',
                                    borderRadius: '50%',
                                    padding: 16,
                                }}
                            />
                        </Box>
                    )}

                    <ActionIcon variant="transparent" size={50} disabled>
                        <IconPlayerSkipForward size={32} />
                    </ActionIcon>
                </Group>
            </Stack>
        </Box>
                </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onTap={onClose} />
        </Sheet>
    );
}
